<template>
	<div class="statistics-content w-full" style="background: #FFFFFF;">
		<div class="w-full layout-side statistics-content-top">
			<div class="statistics-content-top-left layout-left-center">
				<div @click="onSelectedChange(1)" class="statistics-content-top-left-item layout-center"
				     :class="[selected===1?'statistics-content-top-left-item-selected':'']">今日
				</div>
				<div @click="onSelectedChange(2)" class="statistics-content-top-left-item layout-center"
				     :class="[selected===2?'statistics-content-top-left-item-selected':'']">昨日
				</div>
				<div @click="onSelectedChange(3)" class="statistics-content-top-left-item layout-center"
				     :class="[selected===3?'statistics-content-top-left-item-selected':'']">本月
				</div>
			</div>
			<div class="layout-center statistics-content-top-right" @click="onShow">
				<div class="statistics-content-top-right-icon"></div>
				{{ date.y ? date.y + '-' + date.m + '-' + date.d : '自定义' }}
			</div>
		</div>
		<div class="w-full statistics-content-center">
			<div class="w-full-title">
				<div class="title">课程统计</div>
				<div v-if="userDatalt.isDealer" class="w-full-right" @click="receiveData">
					运营数据 》
				</div>

			</div>
			<div class="w-full layout-side card">
				<div class="w-half h-90-px" style="padding-right: var(--sc-6);">
					<!-- background: #E9FBF9;color: #20B9AD; -->
					<div class="w-full h-full border-r layout-side"
					     style="background: #F7FAFE;opacity: 1; padding: var(--sc-pt-line-height) var(--sc-pt-font-size);color: #1A89F9;">
						<div class="h-full w-full">
							<div class="w-full layout-center"><img style="height: var(--base-px-11);margin-right: var(--base-px-5)"
							                                       src="../../../assets/statistics/01.png"/>观看人数
							</div>
							<div class="w-full layout-center"
							     style="margin-top: var(--base-px-10);height: var(--base-px-28);font-size: var(--sc-pt-font-size);font-weight: bold">
								<div style="font-size: var(--sc-font-size);margin-right: 2px;">{{ statisticsData.watchNumber }}</div> 人
							</div>
						</div>
					</div>
				</div>
				<div class="w-half h-90-px" style="padding-left: var(--sc-6);">
					<!-- background: #FBF1EB; color: #F5773E;-->
					<div class="w-full h-full border-r layout-side"
					     style="background: #F7FAFE;opacity: 1; padding: var(--sc-pt-line-height) var(--sc-pt-font-size);color: #1A89F9;">
						<div class="h-full w-full">
							<div class="w-full layout-center"><img style="height: var(--base-px-10);margin-right: var(--base-px-5)"
							                                       src="../../../assets/statistics/02.png"/>完播人数
							</div>
							<div class="w-full layout-center"
							     style="margin-top: var(--base-px-10);height: var(--base-px-28);font-size: var(--sc-pt-font-size);font-weight: bold">
								<div style="font-size: var(--sc-font-size);margin-right: 2px;">{{ statisticsData.finishedNumber }}</div> 人
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- background: #E5F6FE;color: #12A8EF; -->
			<div class="w-full h-90-px card border-r"
			     style="background: #F7FAFE;opacity: 1; padding: var(--sc-pt-line-height) var(--sc-pt-font-size);color: #1A89F9;">
				<div class="w-full layout-left-center"><img
					style="height: var(--sc-pt-line-height);margin-right: var(--base-px-5)"
					src="../../../assets/statistics/03.png"/>完播率
				</div>
				<div class="w-full layout-side" style="margin-top: var(--base-px-10)">
					<div style="width: 100%;position: relative">
						<van-progress :show-pivot="false" :percentage="statisticsData.finishedRate" :stroke-width="7"
						              stroke-width="10"
						              color="#12A8EF"/>
						<div class="progress-title" style="color: #12A8EF;top: -20px">{{ statisticsData.finishedRate }}%</div>
					</div>
				</div>
			</div>
		</div>
		<div class="w-full statistics-content-bottom">
			<div class="title">答题统计</div>
			<!-- background: #EAECFE;color: #4350F0; -->
			<div class="w-full layout-side card">
				<div class="w-half h-90-px" style="padding-right: var(--sc-6);">
					<div class="w-full h-full border-r layout-side"
					     style="background: #F7FAFE;padding: var(--sc-pt-line-height) var(--sc-pt-font-size);color: #1A89F9;">
						<div class="h-full w-full">
							<div class="w-full layout-center"><img
								style="height: var(--sc-pt-line-height);margin-right: var(--base-px-5)"
								src="../../../assets/statistics/04.png"/>答题人数
							</div>
							<div class="w-full layout-center"
							     style="margin-top: var(--base-px-10);height: var(--base-px-28);font-size: var(--sc-pt-font-size);font-weight: bold">
								<div style="font-size: var(--sc-font-size);margin-right: 2px;">{{ statisticsData.questionNumber }}</div> 人
							</div>
						</div>
					</div>
				</div>
				<!-- background: #FEE5E5;color: #EF2112; -->
				<div class="w-half h-90-px" style="padding-left: var(--sc-6);">
					<div class="w-full h-full border-r layout-side"
					     style="background: #F7FAFE;padding: var(--sc-pt-line-height) var(--sc-pt-font-size);color: #1A89F9;">
						<div class="h-full w-full">
							<div class="w-full layout-center"><img
								style="height: var(--sc-pt-line-height);margin-right: var(--base-px-5)"
								src="../../../assets/statistics/05.png"/>正确人数
							</div>
							<div class="w-full layout-center"
							     style="margin-top: var(--base-px-10);height: var(--base-px-28);font-size: var(--sc-pt-font-size);font-weight: bold">
								<div style="font-size: var(--sc-font-size);margin-right: 2px;">{{ statisticsData.correctNumber }}</div> 人
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- background: #E4F1FF;color: #206FD7; -->
			<div class="w-full h-90-px card border-r"
			     style="background: #F7FAFE;padding: var(--sc-pt-line-height) var(--sc-pt-font-size);color: #1A89F9;">
				<div class="w-full layout-left-center"><img
					style="height: var(--sc-pt-line-height);margin-right: var(--base-px-5)"
					src="../../../assets/statistics/06.png"/>正确率
				</div>
				<div class="w-full layout-side" style="margin-top: var(--base-px-10)">
					<div style="width: 100%;position: relative">
						<van-progress :show-pivot="false" :percentage="statisticsData.correctRate" :stroke-width="7"
						              stroke-width="10"
						              color="#206FD7"/>
						<div class="progress-title" style="color: #206FD7;top: -20px">{{ statisticsData.correctRate }}%</div>
					</div>
				</div>
			</div>
		</div>
		<div class="w-full statistics-content-bottom">
			<div class="title">奖励统计</div>
			<div class="w-full layout-side card">
				<div class="w-half h-90-px" style="padding-right: var(--sc-6);">
					<div class="w-full h-full border-r layout-side"
					     style="background: #F7FAFE;padding: var(--sc-pt-line-height) var(--sc-pt-font-size);color: #4350F0;">
						<div class="h-full w-full">
							<div class="w-full layout-center" style="color: #1A89F9;">
								<img style="height: var(--sc-pt-line-height);margin-right: var(--base-px-5);"
								     src="../../../assets/money1.png"/>考核人数
							</div>
							<div class="w-full layout-center"
							     style="margin-top: var(--base-px-10);height: var(--base-px-28);font-size: var(--sc-pt-font-size);font-weight: bold;color: #1A89F9;">
								<div style="font-size: var(--sc-font-size);margin-right: 2px;">{{ statisticsData.rewardNumber }}</div> 人
							</div>
						</div>
					</div>
				</div>
				<div class="w-half h-90-px" style="padding-left: var(--sc-6);">
					<div class="w-full h-full border-r layout-side"
					     style="background: #F7FAFE;padding: var(--sc-pt-line-height) var(--sc-pt-font-size);color: #EF2112;">
						<div class="h-full w-full">
							<div class="w-full layout-center" style="color: #1A89F9;">
								<img style="height: var(--sc-pt-line-height);margin-right: var(--base-px-5);"
								     src="../../../assets/money.png"/>考核金额
							</div>

							<div class="w-full layout-center"
							     style="margin-top: var(--base-px-10);height: var(--base-px-28);font-size: var(--sc-pt-font-size);font-weight: bold;color: #1A89F9;">
								<div style="font-size: var(--sc-font-size);margin-right: 2px;">{{ statisticsData.rewardMoney }}</div> 元
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<van-calendar v-model="show" :show-confirm="false" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm"/>

	</div>
</template>
<script>
import {Calendar} from 'vant';
import {userCenter, workEmployee} from "@/api/homePage";

export default {
	name: "statisticsPage",
	components: {
		Calendar,
	},
	data() {
		return {
			minDate: new Date(2000, 0, 1),
			maxDate: new Date(2100, 0, 31),
			date: {
				y: '',
				m: '',
				d: ''
			},
			show: false,
			selected: 1,
			statisticsData: {
				watchNumber: 0,
				finishedNumber: 0,
				finishedRate: "0.00",
				questionNumber: 0,
				correctNumber: 0,
				correctRate: "0.00"
			},
      userDatalt:{
				isDealer:0
			}
		}
	},
	created() {
    this.userDetails();
		this.getSData({type: 1})
	},
	methods: {
		// 接收组件数据
		receiveData(e) {
		  this.$router.push({path: '/index/group', query: {id: 0, type: "back"}})
		},
		getSData(e) {
			workEmployee(e).then(res => {
				// console.log(res.data.baseInfo)
				if (res.code == 1) {
                    this.statisticsData = res.data
                }
			})
		},
    userDetails() {
      const item = JSON.parse(localStorage.getItem("userDetails"))
      if (item) {
        this.userDatalt = item
      }
      // userCenter().then(res => {
      //   this.userDatalt = res.data.baseInfo
      //   if (!item) {
      //     localStorage.setItem("userDetails", JSON.stringify(this.userDatalt))
      //   } else if (item.id !== this.userDatalt.id) {
      //     localStorage.setItem("userDetails", JSON.stringify(this.userDatalt))
      //   }
      // })
    },
		onSelectedChange(e) {
			this.date = {
				y: '',
				m: '',
				d: ''
			}
			this.selected = e
			this.getSData({type: e + ""})
		},
		onShow() {
			this.show = true
		},
		onConfirm(date) {
			this.show = false;
			this.date = {
				y: date.getFullYear(),
				m: date.getMonth() + 1,
				d: date.getDate()
			};
			this.selected = -1
			this.getSData({date: `${this.date.y}-${this.date.m}-${this.date.d}`})
		},



	}
}
</script>
<style scoped lang="less">
.statistics-content {
	background-color: #f2f3f7;
	margin-top: var(--sc-margin-top);
	z-index: 1;
	position: relative;
	border-radius: var(--sc-border-radius);
	padding: var(--sc-padding);

	.content {
		padding: var(--sc-c-padding);
	}

	.circle-text {
		position: absolute;
		top: 50%;
		left: 0;
		box-sizing: border-box;
		width: 100%;
		padding: var(--sc-ct-padding);
		font-weight: 500;
		font-size: var(--sc-ct-font-size);
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%);
	}

	.progress-title {
		position: absolute;
		right: 0;
		top: var(--sc-pt-top);
		font-size: var(--sc-pt-font-size);
		line-height: var(--sc-pt-line-height);
		font-weight: bold;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}

	.title {
		font-weight: bold;
		font-size: var(--sc-ct-font-size);
		color: #333333;
		line-height: var(--sc-pt-line-height);
		text-align: left;
		font-style: normal;
		text-transform: none;
	}

	.card {
		margin-top: var(--sc-pt-font-size);
		font-weight: 500;
		font-size: var(--sc-ct-font-size);
		line-height: var(--sc-pt-line-height);
		text-align: left;
		font-style: normal;
		text-transform: none;
	}

	.w-half {
		width: 50%;

	}

	.border-r {
		border-radius: var(--sc-8);
	}

	&-top {
		font-size: var(--sc-ct-font-size);

		&-left {
			&-item {
				padding: var(--sc-t-l-i-padding);
				text-align: center;
				margin-right: var(--sc-t-l-i-margin-right);
				cursor: pointer;
				width: var(--sc-68);
				height: var(--sc-28);
				background: #E2E2E2;
				border-radius: var(--sc-8);

				&-selected {
					background: #1A89F9;
					color: #ffffff;
				}
			}
		}

		&-right {
			font-size: var(--sc-pt-font-size);

			&-icon {
				width: var(--sc-pt-line-height);
				height: var(--sc-pt-line-height);
				background: url(../../../assets/custom.png) no-repeat 50%/contain;
				margin-right: var(--sc-6);
			}
		}
	}

	&-center {
		margin-top: var(--sc-24);

	}

	&-bottom {
		margin-top: var(--sc-pt-line-height);
	}
}

.w-full-title{
	display: flex;
	justify-content: space-between;
	align-items: center;
	.title {
		font-weight: bold;
		font-size: var(--sc-ct-font-size);
		color: #333333;
		line-height: var(--sc-pt-line-height);
		text-align: left;
		font-style: normal;
		text-transform: none;
	}
	.w-full-right{
		font-family: Source Han Sans;
		font-size: var(--base-px-14);

		font-weight: 350;
		color: #1A89F9;
	}
}
</style>
